import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "width-wrap" }
const _hoisted_3 = { class: "developer-project" }
const _hoisted_4 = { class: "columns justify-space-between is-vertical-top" }
const _hoisted_5 = { class: "column is-60" }
const _hoisted_6 = { class: "developer-project__title" }
const _hoisted_7 = { class: "developer-project__info" }
const _hoisted_8 = { class: "developer-project__contact" }
const _hoisted_9 = { class: "weight-medium" }
const _hoisted_10 = { class: "developer-project__params" }
const _hoisted_11 = { class: "developer-project__param" }
const _hoisted_12 = { class: "weight-medium" }
const _hoisted_13 = {
  key: 0,
  class: "developer-project__networks"
}
const _hoisted_14 = { class: "networks" }
const _hoisted_15 = { class: "networks__title" }
const _hoisted_16 = { class: "networks__icons" }
const _hoisted_17 = ["title"]
const _hoisted_18 = ["title"]
const _hoisted_19 = ["title"]
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "developer-project__buttons" }
const _hoisted_22 = { class: "buttons buttons-inline gap-medium" }
const _hoisted_23 = { class: "column" }
const _hoisted_24 = { class: "developer-project__logo" }
const _hoisted_25 = { class: "developer-project__description" }
const _hoisted_26 = { class: "weight-medium" }
const _hoisted_27 = {
  key: 0,
  class: "section section--gray"
}
const _hoisted_28 = { class: "width-wrap form" }
const _hoisted_29 = { class: "form-heading" }
const _hoisted_30 = { class: "form-gallery" }
const _hoisted_31 = { class: "thumb-image" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_ReadMore = _resolveComponent("ReadMore")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.ad.title), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('AdDeveloperProjectDetail.address')) + ":", 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.address), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('AdDeveloperProjectDetail.maxFloor')) + ":", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.ad.maxFloor), 1)
                  ])
                ])
              ]),
              (_ctx.ad.hasWaterNetwork || _ctx.ad.hasGasNetwork || _ctx.ad.hasCanalizationNetwork || _ctx.ad.hasElectricityNetwork)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('AdDeveloperProjectDetail.networks')) + ":", 1),
                      _createElementVNode("div", _hoisted_16, [
                        (_ctx.ad.hasWaterNetwork === true)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              title: _ctx.$t('AdParams.hasWaterNetwork'),
                              class: "icon-water"
                            }, _toDisplayString(_ctx.$t('AdParams.hasWaterNetwork')), 9, _hoisted_17))
                          : _createCommentVNode("", true),
                        (_ctx.ad.hasGasNetwork === true)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              title: _ctx.$t('AdParams.hasGasNetwork'),
                              class: "icon-gas"
                            }, _toDisplayString(_ctx.$t('AdParams.hasGasNetwork')), 9, _hoisted_18))
                          : _createCommentVNode("", true),
                        (_ctx.ad.hasCanalizationNetwork === true)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 2,
                              title: _ctx.$t('AdParams.hasCanalizationNetwork'),
                              class: "icon-canalization"
                            }, _toDisplayString(_ctx.$t('AdParams.hasCanalizationNetwork')), 9, _hoisted_19))
                          : _createCommentVNode("", true),
                        (_ctx.ad.hasElectricityNetwork === true)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 3,
                              title: _ctx.$t('AdParams.hasElectricityNetwork'),
                              class: "icon-electricity"
                            }, _toDisplayString(_ctx.$t('AdParams.hasElectricityNetwork')), 9, _hoisted_20))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.ad.virtualTourLink)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onVirtualTour && _ctx.onVirtualTour(...args))),
                        class: "button button--primary reversed"
                      }, _toDisplayString(_ctx.$t('AdDeveloperProjectDetail.virtual-tour')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.ad.videoLink)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onVideo && _ctx.onVideo(...args))),
                        class: "button button--primary reversed"
                      }, _toDisplayString(_ctx.$t('AdDeveloperProjectDetail.video')), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_ResizableImage, {
                  url: _ctx.ad.logoRelativeUrl,
                  width: 200,
                  height: 112.5,
                  alt: "logo"
                }, null, 8, ["url"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('AdDeveloperProjectDetail.description')) + ":", 1),
            _createVNode(_component_ReadMore, {
              text: _ctx.ad.description,
              textEn: _ctx.ad.descriptionEn,
              max: 600,
              isTranslateEnabled: false,
              moreText: _ctx.$t('show-more'),
              lessText: _ctx.$t('show-less')
            }, null, 8, ["text", "textEn", "moreText", "lessText"])
          ])
        ])
      ])
    ]),
    (_ctx.ad.files && _ctx.ad.files.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('AdDeveloperProjectDetail.gallery')), 1)
            ]),
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ad.files, (file, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "thumb",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_ResizableImage, {
                      url: file.url,
                      width: 260,
                      height: 195,
                      hrmode: "max",
                      alt: file.file,
                      draggable: false
                    }, null, 8, ["url", "alt"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}